// 用户管理路由

// 用户信息
const UserInfo = () => import(/* webpackChunkName: "PaymentRecord" */ '@/components/user/user-info.vue')

// 主页
const HomePage = () => import(/* webpackChunkName: "PaymentRecord" */ '@/components/home/homePage.vue')
// 主页
const AccountSettings = () => import(/* webpackChunkName: "PaymentRecord" */ '@/components/setting/AccountSettings.vue')

// 成绩查询CourseDetails
const  ScoreQuery = () => import(/* webpackChunkName: "PaymentRecord" */ '@/components/event/ScoreQuery.vue')

// 成绩查询
const  CoachingCourse = () => import(/* webpackChunkName: "PaymentRecord" */ '@/components/curriculum/CoachingCourse.vue')

// 课程详情
const  CourseDetails = () => import(/* webpackChunkName: "PaymentRecord" */ '@/components/curriculum/CourseDetails.vue')

const  ClassContent = () => import(/* webpackChunkName: "ClassContent" */ '@/components/curriculum/ClassContent.vue')
// 认证中心
const  CertificationCenter = () => import(/* webpackChunkName: "PaymentRecord" */ '@/components/curriculum/CertificationCenter.vue')

export default [
  // 用户信息路由
  {
    path: '/user/UserInfo',
    name: 'UserInfo',
    component: UserInfo
  },
  {
    path: '/home',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/AccountSettings',
    name: 'AccountSettings',
    component: AccountSettings
  },
  {
    path: '/CoachingCourse',
    name: 'CoachingCourse',
    component: CoachingCourse
  },
  {
    path: '/ScoreQuery',
    name: 'ScoreQuery',
    component: ScoreQuery
  },
  {
    path: '/CourseDetails',
    name: 'CourseDetails',
    component: CourseDetails
  },
  {
    path: '/ClassContent',
    name: 'ClassContent',
    component: ClassContent
  },
  {
    path: '/CertificationCenter',
    name: 'CertificationCenter',
    component: CertificationCenter
  }

]



// WEBPACK FOOTER //
// ./src/router/index-user.js